var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 11.9C17.9 11.4029 17.4971 11 17 11C16.5029 11 16.1 11.4029 16.1 11.9V15.1H12.9C12.4029 15.1 12 15.5029 12 16C12 16.497 12.4029 16.9 12.9 16.9H16.1V20.1C16.1 20.597 16.5029 21 17 21C17.4971 21 17.9 20.597 17.9 20.1V16.9H21.1C21.5971 16.9 22 16.497 22 16C22 15.5029 21.5971 15.1 21.1 15.1H17.9V11.9Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 6.89998L18.1 6.89998C18.5971 6.89998 19 6.49703 19 5.99998C19 5.50292 18.5971 5.09998 18.1 5.09998L3.9 5.09998C3.40294 5.09998 3 5.50292 3 5.99998C3 6.49704 3.40294 6.89998 3.9 6.89998Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 10.1C3.40294 10.1 3 10.5029 3 11C3 11.497 3.40294 11.9 3.9 11.9L13.1 11.9C13.5971 11.9 14 11.497 14 11C14 10.5029 13.5971 10.1 13.1 10.1L3.9 10.1Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 15.1C3.40294 15.1 3 15.5029 3 16C3 16.497 3.40294 16.9 3.9 16.9H9.1C9.59706 16.9 10 16.497 10 16C10 15.5029 9.59706 15.1 9.1 15.1H3.9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAddOutline);
export default __webpack_public_path__ + "static/media/list_add_outline.b7f33e09f516f77d1c76e3ddcd3ffb5a.svg";
export { ForwardRef as ReactComponent };